<div class="attachment-container">
    <h4 *ngIf="attachments?.length > 0">
        <b>{{ "ATTACHMENTS_VIEWER.TITLE" | translate }}</b>
    </h4>
    <div *ngIf="hasContentToShow" fxLayoutAlign="center center">
        <button mat-raised-button color="primary" (click)="showContent = !showContent">
            {{
                showContent
                    ? ("ATTACHMENTS_VIEWER.HIDE_CONTENT" | translate)
                    : ("ATTACHMENTS_VIEWER.SHOW_CONTENT" | translate)
            }}
        </button>
    </div>
    <ng-container *ngFor="let anexo of attachments">
        <div *ngIf="showContent">
            <ng-container *ngIf="(anexo.nome | filetype) == 'video'">
                <app-attachment-video
                    [attachment]="anexo"
                    (video-complete)="VideoConvertComplete()"
                ></app-attachment-video>
            </ng-container>
            <ng-container *ngIf="(anexo.nome | filetype) == 'image'">
                <app-attachment-image [attachment]="anexo"></app-attachment-image>
            </ng-container>
            <ng-container *ngIf="(anexo.nome | filetype) == 'audio'">
                <app-attachment-audio [attachment]="anexo"></app-attachment-audio>
            </ng-container>
        </div>
        <ng-container
            *ngIf="
                (anexo.nome | filetype) !== 'video' &&
                (anexo.nome | filetype) !== 'image' &&
                (anexo.nome | filetype) !== 'audio'
            "
        >
            <app-attachment-file [attachment]="anexo"></app-attachment-file>
        </ng-container>
    </ng-container>
</div>
